import React from 'react';
import Main from './Main.js'
import Login from './Login.js';
import MainConfirmation from './MainConfirmation.js';
import LandingSelection from './LandingSelection.js';
import InCompanyForm from './InCompanyForm.js';
import DemoRequest from './DemoRequest.js'
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'


class PricingRouter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      session: { status: false }

    }


  }


  render() {
    // const { classes } = this.props;
    const publicRoutes = [
      {

        path: '/',
        exact: true,
        title: "Main",
        sidebar: () => <div>Users!</div>,
        main: () => <Redirect to="choose_service" />
      },

      {

        path: '/contact_form',
        exact: true,
        title: "Contacto",
        sidebar: () => <div>contact!</div>,
        main: () => <InCompanyForm session={this.props.session} />
      },
      {

        path: '/demo_request',
        exact: true,
        title: "Contacto",
        sidebar: () => <div>contact!</div>,
        main: () => <DemoRequest session={this.props.session} />
      },
      {

        path: '/choose_service',
        exact: true,
        title: "Elegir Servicio",
        sidebar: () => <div>Users!</div>,
        main: () => <LandingSelection session={this.props.session} />
      },
      {
        path: '/selection',
        exact: true,
        title: "Main",
        sidebar: () => <div>Users!</div>,
        main: () => <Main session={this.props.session} />
      },
      {
        path: '/review',
        exact: true,
        title: "Get Kalenis",
        // sidebar: () => <div>Users!</div>,
        main: () => <MainConfirmation session={this.props.session} />
      },
      {

        path: '/form',
        exact: true,
        title: "Get Kalenis",
        // sidebar: () => <div>Users!</div>,
        main: () => <MainConfirmation session={this.props.session} />
      },
      {

        path: '/confirm',
        exact: true,
        title: "Get Kalenis",
        // sidebar: () => <div>Users!</div>,
        main: () => <MainConfirmation session={this.props.session} />
      },
      {

        path: '/login',
        exact: true,
        title: "Login",
        // sidebar: () => <div>Users!</div>,
        main: () => <Login />
      },
    ]

    return (
      <Router basename="/apps">
        <React.Fragment>
          {publicRoutes.map((route, index) => (


            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              component={route.main}

            // sessionStatus={this.state.session.status}
            />


          ))}
        </React.Fragment>
      </Router>
    )

  }
}

export default PricingRouter;